
import { css } from 'lit';
export default css`
.footer-wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
  padding-top: 5rem;
  padding-bottom: 3rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  margin-top: 85px;
}

  .footer-wrapper--hidden {
  display: none;
}

  @media (min-width: 1024px) {

  .footer-wrapper--hidden {
    display: block;
  }
}

  @media (min-width: 1024px) {.footer-wrapper {
    margin-top: 7rem;
  }
  }
`;